import { useEffect, useState } from 'react';
import axios from 'axios';
import { PropertyCard } from '../components/PropertyCard';
import { VAULT } from '../constants/testIds';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Vault() {
  const [properties, setProperties] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const url = filter === 'all' ? `${API}/properties` : `${API}/properties?country=${filter}`;
    axios.get(url).then((r) => setProperties(r.data)).finally(() => setLoading(false));
  }, [filter]);

  const filters = [
    { key: 'all', label: 'All Corridors', testId: VAULT.filterAll },
    { key: 'Nigeria', label: 'Nigeria', testId: VAULT.filterNigeria },
    { key: 'USA', label: 'Hawaii · USA', testId: VAULT.filterUSA },
  ];

  return (
    <div>
      <section className="px-6 md:px-12 lg:px-24 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16">
          <div className="md:col-span-7">
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">The Vault</div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extralight leading-[1] tracking-tight">
              Trophy assets,<br />
              <span className="font-display italic text-[#D4AF37]">privately held.</span>
            </h1>
          </div>
          <div className="md:col-span-5 flex items-end">
            <p className="text-base text-[#A3A3A3] leading-relaxed font-light">
              A curated reserve of trans-atlantic addresses, framed in 4K and vetted under
              sovereign chain-of-custody. Selection is by corridor, not by price.
            </p>
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 pb-12">
        <div className="flex flex-wrap gap-8 border-t border-b border-[#D4AF37]/15 py-6">
          {filters.map((f) => (
            <button
              key={f.key}
              data-testid={f.testId}
              onClick={() => setFilter(f.key)}
              className={`text-[11px] tracking-[0.3em] uppercase transition-colors ${
                filter === f.key ? 'text-[#D4AF37]' : 'text-[#A3A3A3] hover:text-[#F5F5F5]'
              }`}
            >
              {f.label}
            </button>
          ))}
          <div className="ml-auto text-[11px] tracking-[0.3em] uppercase text-[#A3A3A3]">
            {properties.length} {properties.length === 1 ? 'Asset' : 'Assets'} Disclosed
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 pb-24">
        {loading ? (
          <div className="text-center py-32 text-[11px] tracking-[0.3em] uppercase text-[#A3A3A3]">
            Unlocking the vault…
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
            {properties.map((p) => (
              <PropertyCard key={p.id} property={p} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
